// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".yj-sso[data-v-4c155022]{padding:30px;text-align:center;color:#999}", ""]);
// Exports
module.exports = exports;
